export default __webpack_public_path__ + "static/a_love_of_thunder-webfont-7c9b301b04d561df9222c1512cf6fd65.woff";